// Place this in your JavaScript file (e.g., app/javascript/controllers/sidebar_controller.js)
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menuItem"]

  connect() {
    this.updateActiveClass()
    
    // Listen for Turbo navigation events
    document.addEventListener("turbo:load", () => this.updateActiveClass())
    document.addEventListener("turbo:render", () => this.updateActiveClass())
  }

  updateActiveClass() {
    const currentPath = window.location.pathname
    
    // Remove active class from all menu items
    this.menuItemTargets.forEach(item => {
      item.classList.remove("active")
    })
    
    // Add active class to the matching menu item
    this.menuItemTargets.forEach(item => {
      const linkPath = item.getAttribute("href")
      if (linkPath && currentPath === linkPath) {
        item.classList.add("active")
      }
    })
  }
}